import InsightsExportView from "./insights-export-view";

export { InsightsExportView };

export default InsightsExportView;
